import { useContext, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { WorkflowContext } from "../contexts";
import ToggleButton from "./ToggleButton";
import { useTranslation } from "react-i18next";

interface Props {
  text: string;
}

function WorkflowAutomationPanelWebhook(props: Props) {
  const { workflow, updateAutoCreate } = useContext(WorkflowContext);
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(true);

  return (
    <div className="flex flex-col gap-2">
      <button className="flex items-center justify-between w-full font-gilroy font-semibold text-sm text-gray-600 cursor-pointer" onClick={() => setExpanded(b => !b)}>
        <div className="flex items-center gap-2">
          {t("Auto-Create")}
          {workflow.autoCreate && <span className="text-xs text-green font-semibold">{t("Enabled")}</span>}
        </div>
        <ChevronDownIcon className={`w-4 h-4 transition-transform ${expanded ? "rotate-180" : ""}`} />
      </button>
      {expanded &&
        <div className="flex items-center gap-2 text-xs text-gray-600">
          <ToggleButton value={workflow.autoCreate} onChange={updateAutoCreate} bgColor="bg-green" />
          <span>{props.text}</span>
        </div>
      }
    </div>
  );
}

export default WorkflowAutomationPanelWebhook;
